export default function focusWhenDirective() {
	'ngInject';
	return {
		restrict: 'A',
		link: function ($scope, element, attrs) {
			$scope.$watch(attrs.shFocusWhen, function () {
				if ($scope.$eval(attrs.shFocusWhen)) {
					setTimeout(function () {
						try {
							element[0].querySelector('input, textarea, select').focus();
						} catch (e) {
							try {
								element[0].focus();
							} catch (e) {}
						}
					}, 0);
				}
			});
		},
	};
}
